import { GetCreditTransactionsInput } from '@services';
import { useStore } from '@stores';
import { notification } from 'antd';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const CREDITS_TAB_KEY = '9';

export const useMyGarageCredits = () => {
  const { creditStore, sessionStore } = useStore();
  const { balance, creditPacks, transactions, transactionTotal, loading, submitLoading } =
    creditStore;
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const paymentStatus = searchParams.get('payment');
    if (paymentStatus === 'success') {
      notification.success({
        message: 'Payment successful',
        description: 'Credits have been added to your account.',
      });
      creditStore.getBalance();
      setSearchParams({ tab: CREDITS_TAB_KEY });
    } else if (paymentStatus === 'cancelled') {
      notification.warning({
        message: 'Payment cancelled',
        description: 'Your payment was not completed. No charge was made.',
      });
      setSearchParams({ tab: CREDITS_TAB_KEY });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    creditStore.getBalance();
    creditStore.getCreditPacks();
    creditStore.getTransactions(new GetCreditTransactionsInput());

    return () => creditStore.clear();
  }, [creditStore]);

  const handlePurchase = useCallback(
    async (packId: number) => {
      const base = `${window.location.origin}${window.location.pathname}`;
      const result = await creditStore.purchaseCredits({
        creditPackId: packId,
        customerEmail: sessionStore.currentLogin.user?.emailAddress ?? '',
        successUrl: `${base}?tab=${CREDITS_TAB_KEY}&payment=success`,
        cancelUrl: `${base}?tab=${CREDITS_TAB_KEY}&payment=cancelled`,
      });
      if (result?.checkoutUrl) {
        window.location.href = result.checkoutUrl;
      }
    },
    [creditStore, sessionStore]
  );

  const handleManageBilling = useCallback(async () => {
    const base = `${window.location.origin}${window.location.pathname}`;
    const result = await creditStore.getBillingPortalUrl({
      returnUrl: `${base}?tab=${CREDITS_TAB_KEY}`,
    });
    if (result?.portalUrl) {
      window.location.href = result.portalUrl;
    }
  }, [creditStore]);

  return {
    balance,
    creditPacks,
    transactions,
    transactionTotal,
    loading,
    submitLoading,
    handlePurchase,
    handleManageBilling,
  };
};
